import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic BILDKLAR reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fyvxe8aid9a1">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3azjcvu740eam">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3ayhzhj2mffpq">
          Vad <em className="text-red-700" data-id="element-274" data-mp="36wmrjvq6q42z">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31yl5r31djqnt">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2x2mmtuytf0us">
              <div className="text-sm text-amber-500" aria-label="5 av 5 stjärnor" data-id="element-277" data-mp="2s39r0kpyujg2">
                <span aria-hidden="true" data-id="element-278" data-mp="v8589t0m550o">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="q9tzllm210k1">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h817no7u2gkh">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m5b43ntn3sht">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="780kfr6ufgb0"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}